let tefComs: HTMLElement;

const service = {
  bindTefComs: (wc: HTMLElement) => {
    tefComs = wc;
  },

  logInfo: (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console.info(`tef-coms: ${args.map((arg) => String(<string>arg)).join(', ')}`);
  },

  logError(...args: unknown[]) {
    // eslint-disable-next-line no-console
    console.error(`tef-coms: ${args.map((arg) => String(<string>arg)).join(', ')}`);
  },

  fireEvent: (name: string, details = {}) => {
    const event = new CustomEvent('tef-coms', {
      bubbles: true,
      composed: true, // pass through shadow DOM boundaries
      detail: {
        name,
        ...details,
      },
    });
    tefComs.dispatchEvent(event);
  },

  fireError: (name: string, details = {}) => {
    service.fireEvent(name, { level: 'error', ...details });
  },

  fireInfo: (name: string, details = {}) => {
    service.fireEvent(name, { level: 'info', ...details });
  },

  scrollToTop: () => {
    tefComs.scrollIntoView({ behavior: 'smooth' });
  },

  tracker: {
    // eslint-disable-next-line
    reduxActionListener: (_ignored: unknown) => {},
    // eslint-disable-next-line
    doTracking: (name: string, data = {}) => {},
  },
} as const;

export default service;
